import { Component, Input } from '@angular/core';
import { BusinessUser } from '@models/businesses';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import { BusinessUsersState } from '@state/business-users/business-users.state';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TestHooks } from './business-user.hooks';

@UntilDestroy()
@Component({
	selector: 'app-business-user',
	templateUrl: './business-user.component.html',
	standalone: false,
})
export class BusinessUserComponent {
	testHooks = TestHooks;
	user: BusinessUser;

	@Input() bold = false;
	@Input() hideTooltip = false;
	@Input() showName = true;
	@Input() size: 'large' | 'medium' | 'small' | 'xsmall' = 'small';
	@Input() disabled = false;

	@Input() set userId(userId: string) {
		this.getUser$(userId)
			.pipe(untilDestroyed(this))
			.subscribe((x) => {
				this.user = x;
			});
	}

	@Select(BusinessUsersState.getUser) userFilter$: Observable<
		(filter: string) => BusinessUser
	>;

	getUser$(userId) {
		return this.userFilter$.pipe(
			untilDestroyed(this),
			map((filterFn) => filterFn(userId)),
		);
	}
}
